<template>
    <sa-page-layout :btnBackVisible="false" :btnRefreshVisible="true" :showModalLoading="showModalLoading"
        @refresh="onRefresh">

        <template slot="table-filter">
            <sa-filter-component @submit="onSubmit" @reset="onReset">
                <b-row>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Codice Lotto</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroScadenzaCodiciLotto.lottoMatricola"
                                placeholder="Ricerca per codice" />
                        </div>
                    </b-col>
                    <!-- <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Descrizione</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroScadenzaCodiciLotto.descrizione"
                                placeholder="Ricerca per descrizione" />
                        </div>
                    </b-col> -->
                </b-row>
            </sa-filter-component>
        </template>
        <template slot="table-body">
            <MagazzinoScadenziarioListComponent ref="cmpMagazzinoScadenziarioListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SaFilterComponent from "../../../template/layout/components/SaFilterComponent.vue";
import MagazzinoScadenziarioListComponent from "../components/MagazzinoScadenziarioListComponent.vue";
export default {
    components: { SaPageLayout, SaFilterComponent, MagazzinoScadenziarioListComponent },
    data() {
        return {
            showModalLoading: false,
            jsonData: null,
            filtroScadenzaCodiciLotto: { lottoMatricola: null, descrizione: null },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroScadenzaCodiciLotto"]) {
            this.filtroScadenzaCodiciLotto = JSON.parse(sessionStorage["filtroScadenzaCodiciLotto"]);
        }
        this.loadData();
    },
    methods: {
        loadData() {
            this.$refs.cmpMagazzinoScadenziarioListComponent.loadData(this.filtroScadenzaCodiciLotto);
        },
        onSubmit() {
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroScadenzaCodiciLotto"] = JSON.stringify(this.filtroScadenzaCodiciLotto);
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onReset() {
            this.filtroScadenzaCodiciLotto = { codice: null, descrizione: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroScadenzaCodiciLotto"] = JSON.stringify(this.filtroScadenzaCodiciLotto);
            this.loadData();
        },
        onClickNuovo() {
            console.log("nuovo");

        },
    },
};
</script>

<style></style>
